import { useSelector, useDispatch } from "react-redux";
import {
  useCreateReferringProviderMutation,
  useUpdateReferringProviderMutation,
} from "app/store/referringProvider/api/referringProviderApi";
import {
  setShowReferringProviderModal,
  setIsProcessing,
} from "app/store/referringProvider/slice/referringProviderSlice";
import { showSuccessToast, showErrorToast } from "utils/toast";

const useReferringProviderForm = () => {
  const { isUpdateOperation, isProcessing, selectedReferringProvider } =
    useSelector((state) => state.referringProvider);
  const { accounts } = useSelector((state) => state.account);
  const [createReferringProvider] = useCreateReferringProviderMutation();
  const [updateReferringProvider] = useUpdateReferringProviderMutation();
  const dispatch = useDispatch();

  const initialReferringProviderValues = {
    name: selectedReferringProvider?.name || "",
    npi: selectedReferringProvider?.npi || "",
    account: selectedReferringProvider?.account || "",
    default: selectedReferringProvider?.default || false,
    street: selectedReferringProvider?.street || "",
    state: selectedReferringProvider?.state || "",
    zip: selectedReferringProvider?.zip || "",
  };

  const addReferringProvider = async (values) => {
    try {
      const payload = {
        name: values?.name?.replace(/\s+/g, " ").trim(),
        npi: values?.npi?.replace(/\s+/g, " ").trim(),
        account: values?.account?.replace(/\s+/g, " ").trim(),
        default: values?.default,
        street: values?.street?.replace(/\s+/g, " ").trim(),
        state: values?.state?.replace(/\s+/g, " ").trim(),
        zip: values?.zip?.replace(/\s+/g, " ").trim(),
      };

      dispatch(setIsProcessing(true));
      const { message } = await createReferringProvider(payload).unwrap();
      showSuccessToast(message);
      handleModalClose();
    } catch (error) {
      showErrorToast(error?.message || "An error occurred.");
    } finally {
      dispatch(setIsProcessing(false));
    }
  };

  const editReferringProvider = async (id, values) => {
    try {
      const payload = {
        name: values?.name?.replace(/\s+/g, " ").trim(),
        npi: values?.npi?.replace(/\s+/g, " ").trim(),
        account: values?.account?.replace(/\s+/g, " ").trim(),
        default: values?.default,
        street: values?.street?.replace(/\s+/g, " ").trim(),
        state: values?.state?.replace(/\s+/g, " ").trim(),
        zip: values?.zip?.replace(/\s+/g, " ").trim(),
      };

      dispatch(setIsProcessing(true));
      const { message } = await updateReferringProvider({
        id,
        payload,
      }).unwrap();
      showSuccessToast(message);
      handleModalClose();
    } catch (error) {
      showErrorToast(error?.message || "An error occurred.");
    } finally {
      dispatch(setIsProcessing(false));
    }
  };

  const handleFormSubmit = (values) => {
    isUpdateOperation && selectedReferringProvider
      ? editReferringProvider(selectedReferringProvider?._id, values)
      : addReferringProvider(values);
  };

  const handleModalClose = () => {
    dispatch(setShowReferringProviderModal(false));
  };

  return {
    initialReferringProviderValues,
    isProcessing,
    accounts,
    handleFormSubmit,
    handleModalClose,
  };
};

export default useReferringProviderForm;
